import { WorkflowRecord } from "../models/WorkflowRecord";

export interface WorkflowChange {
  readonly type: WorkflowChangeType;
}

export enum WorkflowChangeType {
  REFRESH,
  ADD_NOTE,
  REMOVE_NOTE,
  EDIT_NOTE
}

export interface RefreshNotesChange extends WorkflowChange {
  readonly type: WorkflowChangeType.REFRESH;
}

export function refreshNotesChange(): RefreshNotesChange {
  return {
    type: WorkflowChangeType.REFRESH
  };
}

export function isRefreshChange(change: WorkflowChange): change is RefreshNotesChange {
  return change.type === WorkflowChangeType.REFRESH;
}

export interface AddNoteChange extends WorkflowChange {
  readonly type: WorkflowChangeType.ADD_NOTE;
  readonly content: object;
}

export function addNoteChange(content: object): AddNoteChange {
  return {
    type: WorkflowChangeType.ADD_NOTE,
    content,
  };
}

export function isAddNoteChange(change: WorkflowChange): change is AddNoteChange {
  return change.type === WorkflowChangeType.ADD_NOTE;
}

export interface RemoveNoteChange extends WorkflowChange {
  readonly type: WorkflowChangeType.REMOVE_NOTE;
  readonly id: number;
}

export function removeNoteChange(id: number): RemoveNoteChange {
  return {
    type: WorkflowChangeType.REMOVE_NOTE,
    id
  };
}

export function isRemoveNoteChange(change: WorkflowChange): change is RemoveNoteChange {
  return change.type === WorkflowChangeType.REMOVE_NOTE;
}

export interface EditNoteChange extends WorkflowChange {
  readonly type: WorkflowChangeType.EDIT_NOTE;
  readonly workflowId: number;
  readonly workflowRecord: object;
}

export function editNoteChange(workflowId: number, workflowRecord: object): EditNoteChange {
  return {
    type: WorkflowChangeType.EDIT_NOTE,
    workflowId,
    workflowRecord
  };
}

export function isEditNoteChange(change: WorkflowChange): change is EditNoteChange {
  return change.type === WorkflowChangeType.EDIT_NOTE;
}
